import { render, staticRenderFns } from "./LabelReqView.vue?vue&type=template&id=793d62e0&scoped=true"
import script from "./LabelReqView.vue?vue&type=script&lang=js"
export * from "./LabelReqView.vue?vue&type=script&lang=js"
import style0 from "./LabelReqView.vue?vue&type=style&index=0&id=793d62e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d62e0",
  null
  
)

export default component.exports